export enum GanttTypes {
  month = 'month',
  year = 'year'
}
